var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16657 20.3863C9.79785 20.388 10.4233 20.2649 11.0069 20.0243C11.5905 19.7836 12.1208 19.43 12.5674 18.9838L17.4166 14.1255V1.83301H8.2499V9.70717L5.76574 12.1822C5.09221 12.854 4.63333 13.7106 4.44727 14.6435C4.26121 15.5764 4.35634 16.5436 4.72062 17.4224C5.08489 18.3011 5.70189 19.0519 6.4934 19.5796C7.28492 20.1073 8.21529 20.3881 9.16657 20.3863ZM15.5832 3.66634V5.49967H10.0832V3.66634H15.5832ZM7.0674 13.4838L10.0832 10.4588V7.33301H15.5832V13.3738L11.2657 17.6913C10.7078 18.2493 9.95104 18.5627 9.16198 18.5627C8.37293 18.5627 7.61618 18.2493 7.05824 17.6913C6.50029 17.1334 6.18683 16.3766 6.18683 15.5876C6.18683 14.7985 6.50029 14.0418 7.05824 13.4838H7.0674Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSock);
export default __webpack_public_path__ + "static/media/sock.5db238d4e1602e30d6bc88ff61f5e99b.svg";
export { ForwardRef as ReactComponent };